import { Popper, Paper, Typography } from '@mui/material'
import React from 'react'
import { type Translation } from './model'

interface TranslationPopperProps {
  isTranslationOpen: boolean
  anchorEl: HTMLElement | null
  translatedValue: string
  translations: Translation[]
}
export default function TranslationPopper ({ isTranslationOpen, anchorEl, translatedValue, translations }: TranslationPopperProps): JSX.Element {
  if (translations.length === 0) {
    return (
        <Popper open={isTranslationOpen} placement="top" anchorEl={anchorEl}>
            <Paper>
                <Typography sx={{ p: 2 }}>
                    {translatedValue}
                </Typography>
            </Paper>
        </Popper>
    )
  }

  return (
        <Popper open={isTranslationOpen} placement="top" anchorEl={anchorEl}>
            <Paper>
                <ul>
                    <Typography sx={{ p: 2 }}>
                    {translations.map((translation, key) => (
                        <li key={key}><b>{translation.word}</b>{` (${translation.type}) ${translation.definition}`}</li>
                    ))}
                    </Typography>
                </ul>
        </Paper>
    </Popper>
  )
}
